import template from './service_assignment_rules.html';
import controller from './service_assignment_rules.controller';
import './service_assignment_rules.scss';

let ServiceAssignmentRulesComponent = {
  restrict: 'E',
  bindings: {
  	acl: '=',
    hasACL:'='
  },
  template,
  controller
};

export default ServiceAssignmentRulesComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/service_assignment_rules/service_assignment_rules.component.js